import React from 'react';
//eslint-disable-next-line import/no-unresolved
import img from '@package/components/layout/images/ausl-romagna.jpg?width=1024';

const Background = (props) => (
  <div
    className="searchSections-background"
    {...props}
    style={{ backgroundImage: `url(${img})` }}
  />
);

export default Background;
